import { useCallback, useEffect, useRef, useState } from "react";
import { AxiosProgressEvent } from "axios";
import { CustomProgressBar } from "./custom-progress-bar";
import { fileService } from "../../services/image.service";
import { FileModel } from "../../queries/models/file-model";

interface FileDownloadProps {
  file: FileModel;
}

export function FileDownload({ file }: FileDownloadProps) {
  const [progress, setProgress] = useState<number | undefined>(0);
  const lastProgressUpdateRef = useRef<Date>();
  const onProgress = useCallback(
    (e: AxiosProgressEvent) => {
      const now = new Date();
      if (
        !lastProgressUpdateRef.current ||
        +now - +lastProgressUpdateRef.current >= 100 ||
        e.progress === 1 ||
        e.progress === undefined
      ) {
        lastProgressUpdateRef.current = now;
        setProgress(e.progress && e.progress * 100);
      }
    },
    [lastProgressUpdateRef]
  );

  useEffect(() => {
    if (file) {
      setProgress(0);
    } else {
      setProgress(undefined);
    }
  }, [file]);

  function handleDownload() {
    fileService.downloadFileBlob(file.downloadUrl!, file.fileName, onProgress);
  }

  return (
    <>
      <div
        className="cursor-pointer font-italic hover:text-indigo-600 hover:underline"
        onClick={handleDownload}
      >
        {file.fileName}
      </div>
      {progress !== undefined && progress > 0 && progress < 100 && (
        <div>
          <CustomProgressBar value={progress} />
        </div>
      )}
    </>
  );
}
